import validationExpressions from './validationExpressions';

function validateVideoUrlFormats(val) {
    return validationExpressions.validYouTubeLongUrlReg.test(val) ||
        validationExpressions.validYouTubeShortUrlReg.test(val) ||
        validationExpressions.validVimeoUrlReg.test(val) ||
        validationExpressions.validDailymotionUrlReg.test(val) ||
        validationExpressions.validFacebookUrlReg.test(val);

}

function validateRepeaterItemIdFormat(val) {
   return validationExpressions.validRepeaterItemId.test(val);
}

function validateUUIDFormat(val) {
    return validationExpressions.validUUID.test(val);
}

export default {
    validateVideoUrlFormats,
    validateRepeaterItemIdFormat,
    validateUUIDFormat
};